/* 🤖 this file was generated by svg-to-ts */
export const matIconHistory: {
  name: 'history';
  data: string;
} = {
  name: 'history',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18zm-1 5v5l4.25 2.52.77-1.28-3.52-2.09V8z"/></svg>`
};
